export default {
    freeAccount: 'Free Account',
    login: 'Log In',
    openMenu: 'Open Menu',
    purchase: 'Purchase',
    purchaseTokens: 'Purchase Tokens',
    search: 'Search',
    searchFriends: 'Search Friends',
    searchMessages: 'Search Messages',
    searchNotes: 'Search Notes',
    tokens: 'Tokens',
    openSidebar: 'Open Sidebar',
    closeSidebar: 'Close Sidebar',
}
